/* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchLoanReports } from "../redux/slices/loanReportSlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./PendingDisbursalTest.css";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

// const PendingDisbursalTest = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { loans, loading, error } = useSelector((state) => state.loanReport);

//   const [filterData, setFilterData] = useState({
//     fromDate: "",
//     toDate: "",
//     loanAccountNumber: "",
//     userId: "",
//     userName: "",
//   });

//   const [filteredLoans, setFilteredLoans] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   useEffect(() => {
//     dispatch(fetchLoanReports());
//   }, [dispatch]);

//   useEffect(() => {
//     // ✅ Default: only approved loans
//     setFilteredLoans(loans.filter((loan) => loan.status === "Approved"));
//     setCurrentPage(1);
//   }, [loans]);

//   useEffect(() => {
//     if (error) {
//       toast.error(`Error: ${error}`);
//     }
//   }, [error]);

//   const handleChange = (e) => {
//     setFilterData({ ...filterData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const filtered = loans.filter((loan) => {
//       // ✅ First: must be approved
//       if (loan.status !== "Approved") return false;

//       const { fromDate, toDate, loanAccountNumber, userId, userName } =
//         filterData;
//       const appliedDate = new Date(loan.loanAppliedDate);

//       return (
//         (!fromDate || appliedDate >= new Date(fromDate)) &&
//         (!toDate || appliedDate <= new Date(toDate)) &&
//         (!loanAccountNumber ||
//           loan.loanAccountNumber
//             ?.toLowerCase()
//             .includes(loanAccountNumber.toLowerCase())) &&
//         (!userId || loan.userId?.toString() === userId) &&
//         (!userName ||
//           loan.userName?.toLowerCase().includes(userName.toLowerCase()))
//       );
//     });

//     setFilteredLoans(filtered);
//     setCurrentPage(1);
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="pending-disbursal-container">
//       {/* ✅ Filter Section */}
//       <section className="pending-disbursal-filter-section">
//         <h2 className="pending-disbursal-title">Pending Disbursal Filter</h2>
//         <p className="pending-disbursal-sub-title">
//           Use filters to refine Approved Loans
//         </p>
//         <form className="pending-disbursal-form" onSubmit={handleSubmit}>
//           <div className="pending-disbursal-grid">
//             <div className="pending-disbursal-form-group">
//               <label>From Date</label>
//               <input type="date" name="fromDate" onChange={handleChange} />
//             </div>
//             <div className="pending-disbursal-form-group">
//               <label>To Date</label>
//               <input type="date" name="toDate" onChange={handleChange} />
//             </div>
//             <div className="pending-disbursal-form-group">
//               <label>Loan Account Number</label>
//               <input
//                 type="text"
//                 name="loanAccountNumber"
//                 placeholder="Loan account number"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="pending-disbursal-form-group">
//               <label>Applicant User ID</label>
//               <input
//                 type="text"
//                 name="userId"
//                 placeholder="Applicant user id"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="pending-disbursal-form-group">
//               <label>Applicant User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 placeholder="Applicant user name"
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//           <button type="submit" className="pending-disbursal-submit-btn">
//             Apply Filter
//           </button>
//         </form>
//       </section>

//       {/* ✅ Loan Table */}
//       <section className="pending-disbursal-details-section">
//         <div className="pending-disbursal-table-header">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//         </div>

//         <div className="pending-disbursal-table-container">
//           <table className="pending-disbursal-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>Loan Status</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>View EMI</th>
//                 <th>Loan Card</th>
//                 <th>Disbursement Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="17">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="17">Error: {error}</td>
//                 </tr>
//               ) : currentLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="17">No Approved loans available</td>
//                 </tr>
//               ) : (
//                 currentLoans.map((loan, index) => (
//                   <tr key={loan.id}>
//                     <td>{startIndex + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.userName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{formatDate(loan.loanAppliedDate)}</td>
//                     <td>{formatDate(loan.firstEmiDate)}</td>
//                     <td>{formatDate(loan.disbursalDate)}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanEmiAmount || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() =>
//                           navigate(`/LoanDisbursement/${loan.id}`, {
//                             state: { selectedLoan: loan },
//                           })
//                         }
//                         style={{
//                           marginLeft: "6px",
//                           background: "#1f8b94ff",
//                           color: "#fff",
//                           padding: "5px 10px",
//                           border: "none",
//                           borderRadius: "4px",
//                         }}
//                       >
//                         Disburse Loan
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* ✅ Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="pending-disbursal-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </section>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default PendingDisbursalTest;

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./PendingDisbursalTest.css";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];
const API_URL = "https://narrowitsolution.in/api";

const PendingDisbursalTest = () => {
  const navigate = useNavigate();

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [loans, setLoans] = useState([]);
  const [filteredLoans, setFilteredLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [disbursalModal, setDisbursalModal] = useState(false);
  const [selectedLoanForDisbursal, setSelectedLoanForDisbursal] =
    useState(null);

  const [disbursalData, setDisbursalData] = useState({
    disbursalDate: "",
    remark: "",
  });

  /* ================= FETCH Branch ================= */

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        // console.log("branch data", res.data);
        setBranchs(res?.data.branches);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  // console.log("slected branch",selectedBranch?.id)
  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;
    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch?.id,
          },
        });

        // console.log("center list", res.data?.data);

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;
    if (!selectedCenter?.id) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId: selectedCenter.id,
          },
        });
        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter, selectedBranch]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = currentPage, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(
        `${API_URL}/group-loan/group/list?status=approved`,
        {
          params: {
            superAdminId,
            page,
            limit,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log(res.data.data);
      setLoans(res.data?.data || []);
      // setFilteredLoans(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoans(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);

  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedBranch || !selectedCenter || !selectedGroup) {
      toast.error("Please select Branch, Center, and Group before filtering.");
      return;
    }
    const filtered = loans.filter((loan) => {
      const centerMatch =
        !selectedCenter || loan.centerId === selectedCenter.id;
      const groupMatch = !selectedGroup || loan.groupId === selectedGroup.id;
      const branchMatch =
        !selectedBranch || loan.branchId === selectedBranch.id;
      return centerMatch && groupMatch && branchMatch;
    });

    setFilteredLoans(filtered);
    // setCurrentPage(1);
  };

  const handleDisburseLoan = async () => {
    if (!disbursalData.disbursalDate) {
      toast.error("Select disbursal date");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");

      await axios.post(
        `${API_URL}/group-loan/group/disburse`,
        {
          // groupId: selectedLoanForDisbursal.groupId,
          groupId:selectedGroup.id,
          disbursalDate: disbursalData.disbursalDate,
          createdBy: Number(localStorage.getItem("adminuserId")),
          remark: disbursalData.remark || "Loan disbursed",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Loan disbursed");
      setDisbursalModal(false);
      fetchLoans();
    } catch {
      toast.error("Disbursement failed");
    }
  };

  // modal open then input null
  useEffect(() => {
    if (disbursalModal) {
      setDisbursalData({
        disbursalDate: "",
        remark: "",
      });
    }
  }, [disbursalModal]);

  const handleItemsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };
  return (
    <div className="pending-disbursal-container">
      {/* ✅ Filter Section */}
      <section className="pending-disbursal-filter-section">
        <h2 className="pending-disbursal-title">Pending Disbursal Filter</h2>
        <p className="pending-disbursal-sub-title">
          Use filters to refine Approved Loans
        </p>
        <form className="pending-disbursal-form" onSubmit={handleSubmit}>
          <div className="pending-disbursal-grid">
            {/* Branch */}
            <div className="pending-disbursal-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null); // reset
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="pending-disbursal-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const center = centers.find(
                    (cn) => cn.id === Number(e.target.value)
                  );
                  setSelectedCenter(center);
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="pending-disbursal-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedBranch || !selectedCenter}
                onChange={(e) => {
                  const group = groups.find(
                    (gr) => gr.id === Number(e.target.value)
                  );
                  setSelectedGroup(group);
                }}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* <button type="submit" className="pending-disbursal-submit-btn">
            Apply Filter
          </button> */}
           <div className="filterbtnpdt">
               <button type="submit" className="pending-disbursal-submit-btn">
                    Apply Filter
               </button>
                <button
                  onClick={() => {
                    // setSelectedLoanForDisbursal(loan);
                    setDisbursalModal(true);
                  }}
                  // style={{
                  //   marginLeft: "6px",
                  //   background: "#1f8b94ff",
                  //   color: "#fff",
                  //   padding: "5px 10px",
                  //   border: "none",
                  //   borderRadius: "4px",
                  // }}
                >
                  Disburse Loan
                 </button>
                
           </div>
        </form>
      </section>

      {/* ✅ Loan Table */}
      <section className="pending-disbursal-details-section">
        <div className="pending-disbursal-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="pending-disbursal-table-container">
          <table className="pending-disbursal-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Group Name</th>
                <th>Loan Amount</th>
                {/* <th>Interest Amount</th> */}
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                {/* <th>Disbursal Date</th> */}
                <th>Loan Status</th>
                {/* <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                <th>View EMI</th>
                <th>Loan Card</th> */}
                {/* <th>Disbursement Action</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="16">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="16">Error: {error}</td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="16">No Approved loans available</td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{loan.loanAccountNumber || "N/A"}</td>
                    <td>{loan.memberName || "N/A"}</td>
                    <td>{selectedGroup.groupname}</td>
                    <td>{loan.loanAmount || "N/A"}</td>
                    {/* <td>{loan.loanInterest || "N/A"}</td> */}
                    <td>{loan.loanTenure || "N/A"}</td>
                    <td>{loan.loanRecoveryFrequency || "N/A"}</td>
                    <td>{formatDate(loan.loanAppliedDate)}</td>
                    <td>{formatDate(loan.approvalDate)}</td>
                    {/* <td>{formatDate(loan.disbursalDate)}</td> */}
                    <td>{loan.status || "N/A"}</td>
                    {/* <td>{loan.loanEmiAmount || "N/A"}</td>
                    <td>{loan.loanPayable || "N/A"}</td>
                    <td>{loan.loanType || "N/A"}</td>
                    <td>
                      <button
                        onClick={() => navigate(`/GroupLoanReport/ViewLoanEmi`)}
                      >
                        View EMI
                      </button>
                    </td>
                    <td>
                      <button
                        onClick={() => navigate(`/GroupLoanReport/LoanCard`)}
                      >
                        Loan Card
                      </button>
                    </td> */}
                    {/* <td>
                      <button
                        onClick={() => {
                          setSelectedLoanForDisbursal(loan);
                          setDisbursalModal(true);
                        }}
                        style={{
                          marginLeft: "6px",
                          background: "#1f8b94ff",
                          color: "#fff",
                          padding: "5px 10px",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Disburse Loan
                      </button>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
      {/* ✅ Pagination Controls */}
      {totalPages > 1 && (
        <div className="pending-disbursal-pagination">
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* Disbursal Modal */}
      {disbursalModal && (
        <div className="pending-disbursal-modal-dialog-overlay">
          <div className="pending-disbursal-modal-dialog">
            <h3>Loan Disbursal</h3>

            <div className="pending-disbursal-modal-form">
              <label>Disbursal Date</label>
              <input
                type="date"
                value={disbursalData.disbursalDate || ""}
                // min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setDisbursalData((prev) => ({
                    ...prev,
                    disbursalDate: e.target.value,
                  }))
                }
              />

              <label>Remark</label>
              <textarea
                placeholder="Optional remark"
                value={disbursalData.remark}
                onChange={(e) =>
                  setDisbursalData({
                    ...disbursalData,
                    remark: e.target.value,
                  })
                }
              />
            </div>

            <div className="pending-disbursal-modal-dialog-buttons">
              <button
                className="pending-disbursal-modal-btn-confirm disburse"
                onClick={handleDisburseLoan}
              >
                Disburse Loan
              </button>
              <button
                className="pending-disbursal-modal-btn-cancel"
                onClick={() => setDisbursalModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default PendingDisbursalTest;
